// extracted by mini-css-extract-plugin
module.exports = {"GameOver":"GameOver_GameOver__1gdrz","background":"GameOver_background__1JoBa","snow":"GameOver_snow__3uBzK","active":"GameOver_active__137IW"};